import { VariationGroup } from 'editor/src/store/variants/types';

function getGroupVariationByProductUid(variationGroups: VariationGroup[], productUid: string) {
  return variationGroups.find((group) =>
    group.variationsInfo.find((variant) => variant.variation.productUid === productUid),
  );
}

export default getGroupVariationByProductUid;
